/**
 * Front-end script for the mental calculation block.
 * Wires up all interactive elements: the problem quantity counter,
 * the form validation, the exercise start/answer flow, and the reset/retry buttons.
 */

// Import feature modules
import { setupProblemQuantityCounter } from './files/problem-quantity-counter.js';
import { setupOperandValidation } from './files/mental-calculation-form.js';
import { startExercise, processUserAnswer, resetExerciseState } from './files/mental-calculation-exercise.js';

document.addEventListener("DOMContentLoaded", function () {
	// Initialize the +/- counter for the number of problems
	setupProblemQuantityCounter();

	// Grab all interactive DOM elements used throughout the exercise flow
	const startButton = document.getElementById("startExercise");
	const firstNumberDifficultySelector = document.getElementById("firstNumberDifficulty");
	const secondNumberDifficultySelector = document.getElementById("secondNumberDifficulty");
	const problemOperatorSelector = document.getElementById("problemOperator");
	const problemQuantitySelector = document.getElementById("problemQuantityCount");
	const answerInput = document.getElementById("answerInput");
	const sendButton = document.getElementById("sendForm");
	const resetButton = document.getElementById("resetExercise");
	const retryButton = document.getElementById("retryExercise");

	// Guard: if the main form selectors are missing, the block is not present on this page
	if (!firstNumberDifficultySelector || !secondNumberDifficultySelector || !problemOperatorSelector) {
		return;
	}

	// Validate that the second operand is not harder than the first for division
	setupOperandValidation(firstNumberDifficultySelector, secondNumberDifficultySelector, problemOperatorSelector);

	// Start the exercise when the user clicks "Commencer"
	startButton.addEventListener("click", function () {
		startExercise(firstNumberDifficultySelector, secondNumberDifficultySelector, problemOperatorSelector, problemQuantitySelector);
	});

	// Submit the user's answer via the send button or the Enter key
	sendButton.addEventListener("click", function () {
		processUserAnswer();
	});
	answerInput.addEventListener("keypress", function (e) {
		if (e.key === "Enter") {
			processUserAnswer();
		}
	});

	// Clear the answer input field without moving to the next question
	document.getElementById("resetForm").addEventListener("click", function () {
		// clear the input field
		answerInput.value = '';
		answerInput.focus();
	});

	// Reset and Retry both return to the initial configuration screen
	resetButton.addEventListener("click", resetExerciseState);
	retryButton.addEventListener("click", resetExerciseState);

});
